import React, { createContext, useContext, useState, ReactNode } from "react";
import ForbiddenModal from "@/components/auth/ForbiddenModal";

interface ForbiddenContextType {
  showForbiddenModal: (message: string) => void;
}

const ForbiddenContext = createContext<ForbiddenContextType | undefined>(undefined);

export const useForbidden = () => {
  const context = useContext(ForbiddenContext);
  if (context === undefined) {
    throw new Error("useForbidden must be used within a ForbiddenProvider");
  }
  return context;
};

interface ForbiddenProviderProps {
  children: ReactNode;
}

export const ForbiddenProvider = ({ children }: ForbiddenProviderProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [message, setMessage] = useState("");

  const showForbiddenModal = (errorMessage: string) => {
    setMessage(errorMessage);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setMessage("");
  };

  return (
    <ForbiddenContext.Provider value={{ showForbiddenModal }}>
      {children}
      <ForbiddenModal
        isOpen={isModalOpen}
        message={message}
        onClose={handleCloseModal}
      />
    </ForbiddenContext.Provider>
  );
};
